export const APPLY_UPDATE_CURRENT_TAB = 'APPLY_UPDATE_CURRENT_TAB';

export function isApplyUpdateCurrentTabMessage(data) {
  return data?.type === APPLY_UPDATE_CURRENT_TAB;
}
